import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo } from 'react';
import TranslationProjectModel from 'models/TranslationProjectModel';
import TranslationProjectTranslationItemsModel from 'models/TranslationProjectTranslationItemsModel';
import TranslationProjectPreTranslateDetails from './TranslationProjectPreTranslateDetails';
import { IFields } from 'CMFW/grid/fields';
import { asyncTaskStatusRenderer } from 'CMFW/grid/cellRenderers/asyncTaskStatus';
import { validationStatusRenderer } from 'CMFW/grid/cellRenderers/validationStatus';

export type IProps = {
  courseId: number;
};

const TranslationProjectPreTranslate: React.FC<IProps> = ({ courseId }) => {
  const forceRender = useForceRender();

  // Create the main model for the projects grid (left panel)
  const model = useMemo(() => new TranslationProjectModel({ render: forceRender, courseId }), [forceRender, courseId]);

  // Create the items model for the translation items grid (right panel)
  const itemsModel = useMemo(() => new TranslationProjectTranslationItemsModel({ render: forceRender }), [forceRender]);

  const cellRenderers = useMemo(
    () => ({
      [IFields.async_task_status]: asyncTaskStatusRenderer,
      [IFields.is_validated]: validationStatusRenderer,
    }),
    [],
  );

  const projectName = model.getItemUpdatedValue('name', `Project #${model.itemId}`);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={432}>
          <ContainerLeft>
            <Grid cellRenderers={cellRenderers} />
            <ContainerLeftFooter>
              <ReloadButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            {model.itemId && model.itemId !== model.NEW_CREATE_ID ? (
              <TranslationProjectPreTranslateDetails
                projectId={model.itemId}
                projectName={projectName}
                itemsModel={itemsModel}
                forceRender={forceRender}
              />
            ) : null}
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default TranslationProjectPreTranslate;
